/**
 *
 * KEEP ES5 COMPAT
 *
 * Outside of /src so Create-React-App isn't transpiling
 *
 */
exports.calcExerciseId = function(title) {
	return title.toLowerCase().replace(/ /g, '')
}



//////////////////
// WEBPACK FOOTER
// ./functions/isomorphic/db.js
// module id = 499
// module chunks = 0